import { Outlet } from 'react-router-dom';
import { SearchProvider } from '~/components/searchTable/searchControlBar/SearchContext';

export default function ShippingClaimsLayout() {
  return (
    <SearchProvider entity="Shipping">
      <Outlet />
    </SearchProvider>
  );
}
